"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.toggleOrderByDropdown = exports.setOrderBy = exports.setOrder = exports.setOffset = exports.setLimit = exports.setSearchString = exports.fetchUserListFailed = exports.fetchUserListSuccess = exports.fetchUserListRequest = void 0;
const ActionTypes = require("../../actionTypes/user/list");
const fetchUserListRequest = (offset, limit, order, orderBy, search) => ({
    type: ActionTypes.FETCH_USER_LIST_REQUEST,
    payload: {
        offset,
        limit,
        order,
        orderBy,
        search
    }
});
exports.fetchUserListRequest = fetchUserListRequest;
const fetchUserListSuccess = (payload) => ({
    type: ActionTypes.FETCH_USER_LIST_SUCCESS,
    payload
});
exports.fetchUserListSuccess = fetchUserListSuccess;
const fetchUserListFailed = (error) => ({
    type: ActionTypes.FETCH_USER_LIST_FAILED,
    payload: error
});
exports.fetchUserListFailed = fetchUserListFailed;
const setSearchString = (searchString) => ({
    type: ActionTypes.SET_SEARCH_STRING,
    payload: searchString
});
exports.setSearchString = setSearchString;
const setLimit = (limit) => ({
    type: ActionTypes.SET_LIMIT,
    payload: limit
});
exports.setLimit = setLimit;
const setOffset = (offset) => ({
    type: ActionTypes.SET_OFFSET,
    payload: offset
});
exports.setOffset = setOffset;
const setOrder = (order) => ({
    type: ActionTypes.SET_ORDER,
    payload: order
});
exports.setOrder = setOrder;
const setOrderBy = (orderBy) => ({
    type: ActionTypes.SET_ORDER_BY,
    payload: orderBy
});
exports.setOrderBy = setOrderBy;
const toggleOrderByDropdown = () => ({
    type: ActionTypes.TOGGLE_SORT_BY_DROPDOWN
});
exports.toggleOrderByDropdown = toggleOrderByDropdown;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=list.js.map